import { withPropsOnChange, compose, mapProps } from "recompose";
import { omit } from "ramda";

export const defaultStyle = _style =>
  withPropsOnChange(["style"], ({ style }) => ({
    style: { ..._style, ...style }
  }));

export const omitProps = compose(mapProps, omit);
